<template>
	<dl v-if="ptInitData.colorSizeFlg && !(ptInitData.siteKbn == '4' && !ptInitData.loginKbn)" class="colorSize sort-item">
		<span hidden id="colorSize_lbl">{{ ptInitData.colorTitle + '/' + ptInitData.sizeTitle }}</span>
		<dt>{{ ptInitData.colorTitle }}<span
				v-if="ptInitData.colorTitle && ptInitData.sizeTitle">/</span>{{ ptInitData.sizeTitle }}</dt>
		<dd>
			<select class="colorSizeSelect" v-model="pt125ReqModel.colSzSItemNo" :name="'colorSize'"
				@change="getColSize">
				<option v-for="cs in ptInitData.colSizList" :key="cs.KEY" :value="cs.KEY">{{ cs.VALUE }}</option>
			</select>
		</dd>
	</dl>
</template>
<script>

export default {
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		pt125ReqModel: {
			type: Object,
			default: null
		}
	},
	methods: {

		/*
		* カラーサイズ変更処理
		*/
		getColSize: function (e) {
			var _this = this;
      		const newValue = e.target.value;
			_this.$emit('getColSizeChange',newValue)
			// if (_this.ptInitData.variFlg == 1) {
			// 	_this.pt125ReqModel.sItemNo = _this.pt125ReqModel.colSzSItemNo;
			// 	_this.doinit();
			// }
		},
	},
	name: "colorSize",
	data() {
		return {
		}
	},

}
</script>